import { isFilled } from "@prismicio/client";
import { PrismicNextLink } from "@prismicio/next";
import TagIcon from "@/components/TagIcon";

export function hasArticleGuide(page) {
  const guide = page?.data?.guide;

  return (
    isFilled.contentRelationship(guide) &&
    Boolean(guide.data) &&
    isFilled.keyText(guide.data.preview_title)
  );
}

export default function GuideCard({ page }) {
  if (!hasArticleGuide(page)) return null;

  const guide = page.data.guide;

  return (
    <PrismicNextLink
      field={guide}
      prefetch={false}
      className="flex flex-col items-start gap-4 rounded-2xl bg-beige-30 p-5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bleu"
    >
      <div className="flex flex-row items-center gap-2">
        <TagIcon tag={guide.data.type} isGuide />
        <img src="/icons/dot-separator.svg" alt="" width={3} height={3} aria-hidden />
        {guide.data.preview_nb_article ? (
          <p className="p-blog-xs text-bleu">
            {guide.data.preview_nb_article} articles
          </p>
        ) : null}
      </div>
      <div className="flex w-full flex-row items-center justify-between gap-2">
        <h4 className="h4-n text-bleu">{guide.data.preview_title}</h4>
        <img src="/icons/arrow-right.svg" alt="" width={12} height={8} aria-hidden />
      </div>
    </PrismicNextLink>
  );
}
